import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./component.css";

const FAQSection = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const faqData = [
    {
      question: "What is the full form of ABHA?",
      answer: "A1. ABHA stands for Ayushman Bharat Health Account.",
    },
    {
      question: "Who is eligible for ABHA Card?",
      answer:
        "A2. If you are a citizen of India then you can register to obtain ABHA card.",
    },
    {
      question: "What are the benefits of ABHA Card?",
      answer: (
        <>
          A3. The benefits of ABHA card include:
          <ul>
            <li>Easy access to health records.</li>
            <li>
              Citizens can easily share their health records with healthcare
              providers.
            </li>
            <li>
              Enable healthcare providers to access a patient’s medical history,
              resulting in more effective and personalized treatment.
            </li>
            <li>
              The card is valid in AYUSH related facilities too. Treatments
              include Ayurveda, Yoga and Naturopathy, Unani, and Homeopathy.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "What is ABHA number?",
      answer:
        "A4. It is a 14-digit identification number that serves as a unique identifier for individuals. This number is recognized and accepted by healthcare providers and payers through the country.",
    },
    {
      question: "Is it necessary to register for ABHA Card?",
      answer:
        "A5. No, it is not necessary to register for ABHA card, you can participate at your own free will and choose to create an ABHA number voluntarily. You can also request for permanent deletion or deactivation of ABHA number.",
    },
    {
      question: "What is Ayushman Bharat Health Account (ABHA)?",
      answer:
        "A6. ABHA is a 14 digit unique number used to identify person and authenticate them. It helps to keep track of their medical information and share it with healthcare providers when required (only with the consent of the patient).",
    },
    {
      question:
        "How do I Register/open an Ayushman Bharat Health Account (ABHA)?",
      answer: (
        <>
         A7. Open ABHA account in 3 easy steps:
          <ul>
            <li><strong>Verify Aadhaar details:</strong>   Enter your aadhaar number and verify with OTP received on aadhaar linked mobile number.</li>
            <li>
              <strong>Link mobile mumber with ABHA Address:</strong>   Enter your mobile number and verify with OTP to link with ABHA Address.
            </li>
            <li>
              <strong>Create your ABHA :</strong>   Create your ABHA Number with unique ABHA address.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        " Q8. Is There Any Fee or Charges for Opening or Maintaining an Ayushman Bharat Health Account?",
      answer:
        "A8. There is no fee for registration for Ayushman Bharat Health Account (ABHA).",
    },
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <section className="faq-section section">
      <div className="container">
        <div className="faq-header">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Here you can find answers for all the questions related to the ABHA
            Address
          </p>
        </div>

        <div className="faq-list">
          {faqData.map((faq, index) => (
            <div key={index} className="faq-item">
              <button className="faq-question" onClick={() => toggleFaq(index)}>
                <span className="question-text">{`Q${index + 1}. ${
                  faq.question
                }`}</span>
                <ChevronDown
                  className={`chevron-icon ${
                    openFaq === index ? "rotated" : ""
                  }`}
                  size={20}
                />
              </button>
              {openFaq === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
